import React, { useMemo } from 'react';
var prefix = "sfx-react-ui";

var SelectAllCheck = function SelectAllCheck(_ref) {
  var options = _ref.options,
      allOptions = _ref.allOptions,
      value = _ref.value,
      _ref$selectAllText = _ref.selectAllText,
      selectAllText = _ref$selectAllText === void 0 ? "selectAll" : _ref$selectAllText,
      searchText = _ref.searchText,
      onChange = _ref.onChange,
      transFunc = _ref.transFunc;
  var optionLabels = useMemo(function () {
    return options.map(function (x) {
      return x.label;
    });
  }, [options]);
  var optionValues = useMemo(function () {
    return options.map(function (x) {
      return x.value;
    });
  }, [options]);
  var selectedOptionLabels = useMemo(function () {
    return value.map(function (x) {
      return x.label;
    });
  }, [value]);
  var selectedOptionValues = useMemo(function () {
    return value.map(function (x) {
      return x.value;
    });
  }, [value]);
  var isSelectAll = useMemo(function () {
    // -1: no selected. 0 part selected. 1 all selected
    var isSelectAll = 0;

    if (optionValues.every(function (o) {
      return selectedOptionValues.indexOf(o) < 0;
    })) {
      isSelectAll = -1;
    } else if (optionValues.every(function (o) {
      return selectedOptionValues.indexOf(o) > -1;
    })) {
      isSelectAll = 1;
    }

    return isSelectAll;
  }, [optionValues, selectedOptionValues]);

  var onChangeHandler = function onChangeHandler() {
    if (isSelectAll === 1) {
      // Remove intersection from selected options according to selected options and filtered(searched) options
      var unSelectAllOptions = [];

      if (searchText.length > 0) {
        unSelectAllOptions = selectedOptionLabels.reduce(function (result, o) {
          if (optionLabels.indexOf(o) < 0) {
            var opt = allOptions.find(function (a) {
              return a.label === o;
            });
            opt && result.push(opt);
          }

          return result;
        }, []);
      }

      onChange(unSelectAllOptions);
    } else {
      // Get union set according to selected options and filtered(searched) options
      var selectAllOptions = options;

      if (searchText.length > 0) {
        selectAllOptions = selectedOptionLabels.concat(optionLabels.filter(function (o) {
          return selectedOptionLabels.indexOf(o) < 0;
        })).map(function (r) {
          return allOptions.find(function (a) {
            return a.label === r;
          });
        }).filter(function (opt) {
          return opt !== undefined;
        });
      }

      onChange(selectAllOptions);
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-select-all-container")
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    id: "".concat(isSelectAll === 1 ? "select-menu-chk-all" : "select-menu-chk"),
    checked: isSelectAll > -1,
    onChange: onChangeHandler
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: "".concat(isSelectAll === 1 ? "select-menu-chk-all" : "select-menu-chk")
  }), /*#__PURE__*/React.createElement("label", {
    className: "".concat(prefix, "-select-all"),
    htmlFor: "".concat(isSelectAll === 1 ? "select-menu-chk-all" : "select-menu-chk")
  }, transFunc(selectAllText)));
};

export default SelectAllCheck;